import { Bloc } from "./bloc.model";
import { ResponsePregunta } from "./response_pregunta.model";
import { ResponseQuestionari } from "./response_questionari.model";
import { Resultat } from "./resultat.model";
export class Simulacio {
    blocs: Array<Bloc> = [];

    ambitSeleccionat: any = '';
    tipusSeleccionat: any = '';
    sexeSeleccionat: any = '';
    tipusEdatSeleccionat: any = '';
    dataSeleccionada: any = '';
    edatSeleccionada: any = '';
    unitatEdatEstimadaSeleccionada: any = '';

    teAlgunaObservacio: boolean;

    valoracionsFinals1: any = '';
    altresAccions: string = '';
    vincle: any = '';
    
    observadorPregunta: ResponsePregunta = new ResponsePregunta();
    explicacionsPregunta: ResponsePregunta = new ResponsePregunta();
    grauPregunta: ResponsePregunta = new ResponsePregunta();
    accionsPregunta: ResponsePregunta = new ResponsePregunta();
    collaboraPregunta: ResponsePregunta = new ResponsePregunta();    
    vinclePregunta: ResponsePregunta = new ResponsePregunta();
    coneixementPregunta: ResponsePregunta = new ResponsePregunta();     
    factorsPregunta: ResponsePregunta = new ResponsePregunta();    
    altresFactorsObservacions: ResponsePregunta = new ResponsePregunta();
    
    responseQuestionari: ResponseQuestionari;
    resultat: Resultat;
}